//存折线图数据
import { GET_RECORD_DATA } from "./actionType";

const defaultState = {
  info: [],//展示数据
  showData: [],//直线图数据
};
const Reducer = (state = defaultState, action) => {
  switch (action.type) {
    case GET_RECORD_DATA://存
      return { ...state, ...action.recordData };
    default:
      return state;
  }
};

export default Reducer;
